import { usePostApiV1AccessLogin } from '@/shared/api/generated/hooks/accessController/usePostApiV1AccessLogin';
import { useSession } from '@/shared/store/hooks/useSession';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Hook de autenticação — realiza login e armazena a sessão.
 *
 * Encapsula `usePostApiV1AccessLogin` do Kubb com lógica de sessão.
 *
 * @example
 * ```tsx
 * const { mutate: login, isPending, error } = useLogin();
 * login({ data: { user: 'admin', password: '1234', accessType: 1 } });
 * ```
 */
export function useLogin() {
  const { login } = useSession();

  return usePostApiV1AccessLogin({
    mutation: {
      onSuccess: data => {
        if (!data) return;

        login({
          userId: String(data.userId ?? ''),
          name: data.userName ?? '',
          email: data.email ?? '',
          roles: data.roles ?? [],
          accessToken: data.token ?? '',
          tokenExpireDate: new Date(data.tokenExpireDate ?? ''),
          personId: data.personId ?? data.userId ?? 0,
          controllerPermissions: (data.controllerPermissions ?? [])
            .filter(
              (p): p is { controllerId: number; controllerName: string } =>
                p.controllerId != null && p.controllerName != null,
            )
            .map(p => ({
              controllerId: p.controllerId,
              controllerName: p.controllerName,
            })),
        });
      },
    },
  });
}
